/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { PutAway03Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const putAway03ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const putAway03FetchPutAway03Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const putAway03FetchPutAway03Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const putAway03AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const putAway03RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const putAway03SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const putAway03CreatePutAway03Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const putAway03CreatePutAway03Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PutAway03Types.PUT_AWAY03_RESET_TIMESTAMP]: putAway03ResetTimestamp,
  [PutAway03Types.PUT_AWAY03_FETCH_PUT_AWAY03_LOADING]: putAway03FetchPutAway03Loading,
  [PutAway03Types.PUT_AWAY03_FETCH_PUT_AWAY03_SUCCESS]: putAway03FetchPutAway03Success,
  [PutAway03Types.PUT_AWAY03_ADD_SELECTED_DOCUMENTS]: putAway03AddSelectedDocuments,
  [PutAway03Types.PUT_AWAY03_REMOVE_SELECTED_DOCUMENTS]: putAway03RemoveSelectedDocuments,
  [PutAway03Types.PUT_AWAY03_SET_WORKSPACE_VISIBLE]: putAway03SetWorkspaceVisible,
  [PutAway03Types.PUT_AWAY03_CREATE_PUT_AWAY03_LOADING]: putAway03CreatePutAway03Loading,
  [PutAway03Types.PUT_AWAY03_CREATE_PUT_AWAY03_SUCCESS]: putAway03CreatePutAway03Success
});
